/*
===============================================================================
FUNZIONE DI ISCRIZIONE ALLA NEWSLETTER SPECIFICA PER LA WELLDONE
===============================================================================
*/
function submitNewsletterWelldone(nlemail, nlnome, nlcognome, nlordinenum, nlordinedata, nlsalvadanaio) {

  // Controllo che tutti i parametri obbligatori siono stati passati
  try {
    if (nlemail === undefined || nlemail === null) throw 'email';
    if (nlnome === undefined || nlnome === null) throw 'nome';
    if (nlcognome === undefined || nlcognome === null) throw 'cognome';
    if (nlordinenum === undefined || nlordinenum === null) throw 'numero ordine';
    if (nlordinedata === undefined || nlordinedata === null) throw 'data ordine';
    if (nlsalvadanaio === undefined || nlsalvadanaio === null) throw 'salvadanaio';
  } catch (err) {
    console.log('Errore - Argomento ' + err + ' non passato');
    return;
  }

  // Definisco e assegno le variabili necessarie alla richiesta Mailup
  var lista = 1;
  var gruppo = 38; // Concluso acquisto su Gioielloro
  var ritCodice = 1; // Attiva la risposta alla request sotto forma numerica
  var conferma = false; // Disattiva la conferma di iscrizione
  var csvFldNames = 'campo1;campo2;campo13;campo14;campo34;';
  var csvFldValues = '' + nlnome + ';' + nlcognome + ';' + nlordinenum + ';' + nlordinedata + ';' + nlsalvadanaio + ';';

  // Passo l'email, il nome, il cognome, il numero di ordine, la data di ordine
  // e il salvadanaio alla pagina proxy che eseguirà una GET alla console mailup
  // per inserirlo nella lista e nel gruppo degli iscritti alla newsletter
  $.ajax({
    url: '../proxy_newsletter.php',
    type: 'POST',
    data: {
      list: lista,
      group: gruppo,
      retCode: ritCodice,
      confirm: conferma,
      email: nlemail,
      csvFldNames: csvFldNames,
      csvFldValues: csvFldValues
    },
    success: function (data) {
      console.log(data);
      // Controllo se l'iscrizione è andata a buon fine (risposta 0)
      // if (parseInt(data) === 0) {
      //   console.log('ok');
      // } else if (parseInt(data) === 3) {
      //   console.log('cliente esistente');
      // } else {
      //   console.log('errore');
      // }
    }
  });
}



//
$(document).ready(function () {

  // controllo se sono nella welldone
  if ($('#welldone-wrapper').length) {
    // controllo se il cliente ha scelto di ricevere la newsletter
    if (parseInt($('input[name="nl-select"]').val()) === 0) {

      (function () {
        // prendo i valori da passare alla funzione di iscrizione
        var email = $('input[name="nl-email"]').val();
        var nome = $('input[name="nl-nome"]').val();
        var cognome = $('input[name="nl-cognome"]').val();
        var ordineNumero = $('input[name="nl-ordernum"]').val();
        var ordineData = $('input[name="nl-orderdata"]').val();
        var salvadanaio = parseInt($('input[name="nl-salvadanaio"]').val());
        // rimuovo l'orario
        ordineData = ordineData.slice(0, 10);

        submitNewsletterWelldone(email, nome, cognome, ordineNumero, ordineData, salvadanaio);

      })();
    }
  }
});


// Selezione destinazione confezione regalo
// $(document).ready(function () {

//   $('.gift-destination').on('click', function () {
//     $('.gift-destination').removeClass('active');
//     $(this).addClass('active');
//   });

//   $('#submit-gift-type').on('click', function () {
//     const orderNumber = $('#welldone-wrapper').data('orderid');
//     const destination = $('.gift-destination.active').data('dest');
//     if (destination !== undefined) {
//       console.log(destination);

//       $.ajax({
//         // url: '../email/email-gift-type.php',
//         url: '../email-gift-type.php',
//         method: 'POST',
//         data: {
//           ordine_id: orderNumber,
//           destinazione: destination
//         },
//         success: function (data) {
//           console.log(data);
//           if (data === 'ok') {
//             $('#welldone-gift').addClass('hidden');
//             $('#welldone-gift-done').removeClass('hidden');
//           }
//         }
//       });

//     }
//   });

// });
